import { styled, Button as MuiButton } from '@mui/material';

const RoundedButton = styled(MuiButton)<any>({
  fontSize: '1rem',
  lineHeight: '1rem',
  margin: 0,
  padding: '0 2rem',
  borderRadius: '8px',
  border: '1px solid transparent',
  backgroundColor: 'var(--razzmatazz)',
  color: 'white',
  userSelect: 'none',
  transition: 'background-color 140ms ease',
  height: '3rem',
  minHeight: '3rem',
  overflow: 'hidden',
  textTransform: 'none',
  '&:hover': {
    backgroundColor: 'rgba(231, 21, 117, .95)'
  }
});

export default RoundedButton;